<template>
  <div>
    <div ref="content">
      <slot :isDownloading="!isDownloading" />
    </div>
    <slot name="additionalContent" />
    <div class="d-flex flex-column align-items-end mt-4">
      <loading-button
        :button-text="trans('courses.certificate.download')"
        :loading="isDownloading"
        @click="downloadPDF"
        variant="secondary"
      />
    </div>
  </div>
</template>

<script>
import { toJpeg } from "html-to-image";
import { jsPDF } from "jspdf";
import LoadingButton from "../atoms/LoadingButton.vue";

export default {
  name: "DownloadableContent",
  components: { LoadingButton },
  data() {
    return {
      isDownloading: false,
    };
  },
  props: {
    serviceName: String,
    isAugmented: Boolean,
  },
  methods: {
    downloadPDF() {
      this.isDownloading = true;

      this.$nextTick(() => {
        this.download();
      });
    },
    async download() {
      trackEvent("downloadCertificate", {
        serviceName: this.serviceName,
        isAugmented: this.isAugmented,
      });

      await toJpeg(this.$refs.content, {
        cacheBust: true,
        quality: 0.95,
        backgroundColor: "#fff",
      })
        .then((dataUrl) => {
          const contentWidth = this.$refs.content.offsetWidth / 1.5;
          const contentHeight = this.$refs.content.offsetHeight / 1.5;
          const doc = new jsPDF("l", "px", [contentWidth, contentHeight]);
          // Add content
          doc.addImage(dataUrl, "JPEG", 0, 0, contentWidth, contentHeight);
          doc.save("certificate");
          this.isDownloading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
